import {getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";
import {
    ContainerDNUStatisticsSnapshot,
    ContainerDNUStatisticsSnapshotEntity
} from "../../../model/container-dnu-statistics-snapshot";

export type ContainerDNUStatisticsSnapshotSelectorProps = {
    // selector props
};

export const containerDNUStatisticsSelector = () => createSelector(
    [getUseQueryResultData<ContainerDNUStatisticsSnapshot[]>],
    (data) => {
        return selectContainerDNUStatisticsSnapshotsAndTransform(
            data ?? [], {});
    }
);

export const containerDNUStatisticSelector = () => createSelector(
    [getUseQueryResultData<ContainerDNUStatisticsSnapshot>],
    (data) => {
        return data ? transformContainerDNUStatisticsSnapshot(data) : undefined;
    }
);

export const selectContainerDNUStatisticsSnapshots = (values?: ContainerDNUStatisticsSnapshot[], selector?: ContainerDNUStatisticsSnapshotSelectorProps): ContainerDNUStatisticsSnapshot[] => {
    if (!values) {
        return [];
    }

    return values.filter((v) => {
        let filterIn = true;
        return filterIn;
    });
};

export const transformContainerDNUStatisticsSnapshot = (value: ContainerDNUStatisticsSnapshot): ContainerDNUStatisticsSnapshotEntity => {
    return ContainerDNUStatisticsSnapshotEntity.from(value)
}

export const selectContainerDNUStatisticsSnapshotsAndTransform = (values?: ContainerDNUStatisticsSnapshot[], selector?: ContainerDNUStatisticsSnapshotSelectorProps): ContainerDNUStatisticsSnapshotEntity[] => {
    const selected = selectContainerDNUStatisticsSnapshots(values, selector);
    return selected.map(transformContainerDNUStatisticsSnapshot);
};
